export const SuccessPageRouting = {
  path: "/successPage",
  name: "successPage",
  meta: { title: "设置成功" },
  component: () => import(/* webpackChunkName: "join" */ "@/views/join/h5/success-page/index.vue"),
  children: [],
};
